import React, { useState } from 'react'
import ViewRole from './view'
import EditRole from './edit'

const RoleField = ({
    user = {},
    canEdit
}) => {

    const [ isEditing, setEditing ] = useState(false)

    if (isEditing) {
        return (<EditRole user={user} onClose={() => setEditing(false)} />)
    }

    return (
        <ViewRole user={user} onEdit={() => setEditing(true)} disabled={!canEdit} />
    )

}

export default RoleField